import {EditorConfig} from '../../../constants/editorConfig'
import {removeNodes} from '../../../editorActions'

const InteractionMode = EditorConfig.INTERACTION_MODES

/**
 * Sync stage draggable and cursor with PAN mode (so toolbar toggle and Space key both work).
 */
function applyPanModeToStage(stage, isPan) {
    stage.draggable(isPan)
    const container = stage.container()
    if (container) {
        container.style.cursor = isPan
            ? EditorConfig.KEYBOARD.PAN_CURSOR_ACTIVE
            : EditorConfig.KEYBOARD.PAN_CURSOR_INACTIVE
    }
}

/**
 * Bind keyboard shortcuts.
 */
export function bindKeyboardInput(editor, stage, interaction, {isTextEditing} = {}) {
    // Sync stage/cursor with interaction mode so PAN works for both Space key and toolbar toggle
    const unsubscribe = interaction?.subscribe?.(function onModeChange(nextMode) {
        applyPanModeToStage(stage, nextMode === InteractionMode.PAN)
    })
    applyPanModeToStage(stage, interaction.is(InteractionMode.PAN))

    /** @param {KeyboardEvent} e */
    function onKeyDown(e) {
        if (isTextEditing?.()) return

        if (e.key === EditorConfig.KEYBOARD.DELETE_KEY) {
            editor.dispatch(removeNodes(editor.getState().selection.nodeIds))
        }

        if ((e.ctrlKey || e.metaKey) && e.key === EditorConfig.KEYBOARD.UNDO_KEY) {
            editor.undo()
        }

        if ((e.ctrlKey || e.metaKey) && e.key === EditorConfig.KEYBOARD.REDO_KEY) {
            editor.redo()
        }

        if (e.code === EditorConfig.KEYBOARD.PAN_KEY_CODE && !interaction.is(InteractionMode.PAN)) {
            interaction.setMode(InteractionMode.PAN)
        }
    }

    function onKeyUp(e) {
        if (e.code === EditorConfig.KEYBOARD.PAN_KEY_CODE) {
            interaction.reset()
        }
    }

    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)

    return function unbind() {
        unsubscribe?.()
        applyPanModeToStage(stage, false)
        window.removeEventListener('keydown', onKeyDown)
        window.removeEventListener('keyup', onKeyUp)
    }
}
